module.exports = __webpack_public_path__ + "img/pro_one_1.65b9a7c0.jpg";